<template>
  <div class="mb-3">
    <Alert
      type="alert-info"
      text="Schedule your chats to run automatically on set interval of time.
      Note: Only Tasks in the first Action of the Chat will be executed. Follow UTC Timezone to mention timings"
    ></Alert>
    <AlertLink link="/user-guide#Schedule" text="Read more about schedule here"></AlertLink>
    <div
      class="mb-3"
      v-for="(item, index) in schedules"
      :key="index"
    >
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">Every</span>
        </div>
        <input
          type="number"
          class="form-control"
          min=1
          v-model="item.occurrenceInterval"
          placeholder="Interval"
        />
        <select class="form-control" v-model="item.occurrenceType">
          <option value="null">Select Timeframe</option>
          <option
            v-for="(occ, index) in occurrenceTypes"
            :value="occ"
            :key="index"
          >{{occ}}</option>
        </select>
        <select class="form-control" v-model="item.chat_name">
          <option value="null">Select Chat</option>
          <option
            v-for="(chat_name, index) in chat_names"
            :value="chat_name"
            :key="index"
          >{{chat_name}}</option>
        </select>
        <div class="input-group-append">
          <button @click="removeSchedule(index)" class="btn btn-outline-danger btn-sm">X</button>
        </div>
      </div>

      <div class="input-group">
        <select class="form-control" v-model="item.occurrenceTime.month_day" v-if="item.occurrenceType =='Month'">
          <option value="null">Select Day</option>
          <option
            v-for="(day, index) in monthDays"
            :value="day"
            :key="index"
          >{{day}}</option>
        </select>
      </div>

      <div class="input-group">
        <select class="form-control" v-model="item.occurrenceTime.week_day" v-if="item.occurrenceType == 'Week'">
          <option value="null">Select Day</option>
          <option
            v-for="(day, index) in weekDays"
            :value="day"
            :key="index"
          >{{day}}</option>
        </select>
      </div>

      <div class="input-group">
        <select class="form-control" v-model="item.occurrenceTime.hour" v-if="['Month', 'Week', 'Day'].includes(item.occurrenceType)">
          <option value="null">Select Hour</option>
          <option
            v-for="(hour, index) in hours"
            :value="hour"
            :key="index"
          >{{hour}}</option>
        </select>
      </div>

      <div class="input-group">
        <select class="form-control" v-model="item.occurrenceTime.minute" v-if="['Month','Week','Day','Hour'].includes(item.occurrenceType)">
          <option value="null">Select Minute</option>
          <option
            v-for="(minute, index) in minutes"
            :value="minute"
            :key="index"
          >{{minute}}</option>
        </select>
      </div>
        
        
    </div>
    <button @click="addSchedule" class="btn btn-outline-info btn-block">Add Schedule</button>
  </div>
</template>


<style>
.error {
  border-style: solid;
  border-color: red;
}
</style>


<script>
import Alert from "@/components/Alert.vue";
import AlertLink from "@/components/AlertLink.vue";



export default {
  name: "Schedule",
  data: function() {
      return{
          occurrenceTypes: ['Minute', 'Hour', 'Day', 'Week', 'Month'],
          weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          monthDays: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
          hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
          minutes: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,
                    31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59]
        };
    },
  components:{
    Alert,
    AlertLink
  },
  props: {
    schedules: Array,
    chat_names: Array
  },
  methods: {
    removeSchedule: function(index) {
      this.$emit("removeSchedule", index);
    },
    addSchedule: function() {
      this.$emit("addSchedule", this.schedules);
    }
  }
};
</script>
